import * as React from "react";
import AuthService from "../../services/authService";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCaretDown, faChevronRight, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import Translate from "../../common/functions/translate";
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import { withRouter } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import LocalOffersService from "../../services/localDataServices/localOffersService";
import SynchronizationService from "../../services/synchronizationService";
import Spinner from '../../common/components/spinner/spinner';
import UserService from "../../services/userService";

interface IProps {
  history: any;
  onUserLogout: any;
  mobileView: boolean;
  closeDrawer: any;
}

interface IState {
  isLoading: boolean;
  anchorEl: any;
  isVisibleConfirmDialog: boolean;
  logOutConfirmationMassage: string;
}

class UserMenuComponent extends React.Component<IProps, IState> {
  authService = new AuthService();
  localOffersService = new LocalOffersService();
  synchronizationService = new SynchronizationService();
  _isMounted = false;
  userService = new UserService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      anchorEl: null,
      isVisibleConfirmDialog: false,
      logOutConfirmationMassage: Translate("Are you sure you want to logout"),
    };

  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  handleClickProfile = () => {
    if (this.props.closeDrawer)
      this.props.closeDrawer();

    this.setState({ anchorEl: null }, () => this.props.history.push('/userprofile'))
  }

  handleClickLogout = () => {
    let confirmMessage = Translate("Are you sure you want to logout");

    this.localOffersService.userHasNotSynchronizedOffers().then(
      (result) => {
        if (result) {
          confirmMessage = Translate("You have not synchronized offers that may be lost. Do you want to logout?");
        }

        this.setState({
          anchorEl: null,
          isVisibleConfirmDialog: true,
          logOutConfirmationMassage: confirmMessage
        });
      }).catch(error => {
        this.setState({
          anchorEl: null,
          isVisibleConfirmDialog: true
        });
      })

    this.setState({
      anchorEl: null,
      isVisibleConfirmDialog: true
    });
  }

  logoutConfirmClick = () => {
    sessionStorage.removeItem('offerFilterData');

    if (this.props.closeDrawer)
      this.props.closeDrawer();

    if (navigator.onLine) {
      this.setState({
        isLoading: true
      })
      this.localOffersService.getOffersForSynchronization().then(
        (offers: any) => {
          if (offers && offers.length) {
            this.synchronizationService.reportOffers(offers).then(
              (result) => {
                this.localOffersService.setOffersReported(offers).then(
                  () => {
                    this.doLogout();
                  }).catch(error => {
                    console.log(error);
                    this.doLogout();
                  })
              }).catch(error => {
                console.log(error);
                this.doLogout();
              })
          } else {
            this.doLogout();
          }
        }).catch(error => {
          console.log(error);
          this.doLogout();
        })
    } else {
      this.doLogout();
    }
  }

  doLogout = () => {
    localStorage.setItem('regionId', this.authService.getRegionId());
    if (this._isMounted) {
      this.setState({ anchorEl: null, isVisibleConfirmDialog: false, isLoading: false }, () => {
        this.authService.logout()
        this.props.onUserLogout()
        this.props.history.replace('/login');
      });
    } else {
      this.authService.logout()
      this.props.onUserLogout()
      this.props.history.replace('/login');
    }
  }

  render() {

    return (

      <>
        {this.authService.isAuthenticated()
          ? <div style={{ marginRight: !this.props.mobileView ? "20px" : 0 }}>
            {this.state.isLoading ? <Spinner /> : null}
            {!this.props.mobileView ?
              <>
                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleClick}>
                  <div style={{ textTransform: "none", color: "#777", display: "flex", alignItems: "center" }}>
                    <Avatar style={{ width: "24px", height: "24px", fontSize: "1em", marginRight: "7px" }}>
                      <FontAwesomeIcon icon={faUser} />
                    </Avatar>
                    <span className="header-user-name" style={{ marginRight: "7px" }}>{this.authService.getUserName()} ({Translate(this.authService.getUserRole())}) </span>
                    <FontAwesomeIcon icon={faCaretDown} />
                  </div>
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  keepMounted
                  open={this.state.anchorEl ? true : false}
                  onClose={this.handleClose}
                >
                  <MenuItem onClick={this.handleClickProfile}>{Translate('Profile')}</MenuItem>
                  <MenuItem onClick={this.handleClickLogout}>{Translate('Logout')}</MenuItem>
                </Menu>
              </> :
              <>
                <li key='profile' style={{ marginTop: 40 }} onClick={() => this.handleClickProfile()}>
                  <div className="item-icon">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                  <div className="item-info">
                    <div className="item-name">
                      {Translate("Profile")}
                    </div>
                  </div>
                  <div className="item-actions">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </li>
                <li key='logout' onClick={() => this.handleClickLogout()}>
                  <div className="item-icon">
                    <FontAwesomeIcon icon={faSignOutAlt} />
                  </div>
                  <div className="item-info">
                    <div className="item-name">
                      {Translate("Logout")}
                    </div>
                  </div>
                  <div className="item-actions">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </li>
              </>
            }
          </div>
          : null}

        {this.state.isVisibleConfirmDialog ?
          <ConfirmDialog
            headerTitle={Translate("Logout")}
            isVisible={this.state.isVisibleConfirmDialog}
            yesClick={this.logoutConfirmClick}
            noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
            {this.state.logOutConfirmationMassage}
          </ConfirmDialog>
          : null}

      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang,
    isUserLogged: state.common.isUserLogged
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT })
  }
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(UserMenuComponent));
